import store from "../localStorage";

export default class modalManage {
    static default = () => store.dispatch({type: 'MODAL_DEFAULT'});
    static show = (modalId) => store.dispatch({type: 'MODAL_SHOW', modalId: modalId});
    static close = (modalId) => store.dispatch({type: 'MODAL_CLOSE', modalId: modalId});
}